import api from '.'

export const sites = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/sites`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/sites`, null, success, fail)
  },
  get (id, success, fail) {
    api.authenticatedRequest('GET', `/sites/${id}`, null, success, fail)
  },
  update (id, data, success, fail) {
    api.authenticatedRequest('PUT', `/sites/${id}`, data, success, fail)
  },
  delete (id, success, fail) {
    api.authenticatedRequest('DELETE', `/sites/${id}`, null, success, fail)
  },
  addMember (id, participantId, success, fail) {
    api.authenticatedRequest('PUT', `/sites/${id}/memberships/${participantId}`, null, success, fail)
  },
  removeMember (id, participantId, success, fail) {
    api.authenticatedRequest('DELETE', `/sites/${id}/memberships/${participantId}`, null, success, fail)
  },
  getMessages (siteId, page, pageSize, success, fail) {
    api.authenticatedRequest('GET', `/sites/${siteId}/messages?page=${page || 1}&page_size=${pageSize || 30}`, null, success, fail)
  },
  createMessage (siteId, data, success, fail) {
    api.authenticatedRequest('POST', `/sites/${siteId}/messages`, data, success, fail)
  },
  readMessages (siteId, success, fail) {
    api.authenticatedRequest('PUT', `/sites/${siteId}/messages/read`, null, success, fail)
  },
  getUnreadCounts (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/messages/unread`, null, success, fail)
  },
  broadcastMessage (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/messages/broadcast`, data, success, fail)
  }
}
